import serverCall from "../../serverCall";

const getAllGroup = () => {
  try {
    const response = serverCall.get(`/training-group/getAll`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getAllSuggettions = () => {
  try {
    const response = serverCall.get(`/training-group/allSuggestion`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getGroupDetails = (groupId) => {
  try {
    const response = serverCall.get(
      `/training-group/groupDetails?groupId=${groupId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createTrainingGroup = (body) => {
  try {
    const response = serverCall.post(`/training-group/create`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateGroup = (groupId, body) => {
  try {
    const response = serverCall.patch(
      `/training-group/updateDetails?groupId=${groupId}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = (userId) => {
  try {
    const response = serverCall.delete(`/admin/user/delete/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteGroup = (groupId) => {
  try {
    const response = serverCall.delete(`/admin/deleteGroup?groupId=${groupId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteSuggestion = (groupId, field, itemId) => {
  try {
    const payload = {
      groupId,
      field,
      itemId,
      aiFramework: field === "aiFramework" || field === "framework" || field === "ai_framework" ? itemId : undefined,
    };
    const response = serverCall.delete(
      `/training-group/prompt-item?groupId=${groupId}&field=${field}&itemId=${itemId}&aiFramework=${field === "aiFramework" || field === "framework" || field === "ai_framework" ? itemId : ""}`,
      { data: payload }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/* const updateAdminProfile = (body, userId) => {
  try {
    const response = serverCall.patch(`/admin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const adminFileUpload = (body) => {
  try {
    const response = serverCall.post(`/company/update-company`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const getCompany = () => {
  try {
    const response = serverCall.get(`/company/get-companies`);
    return response;
  } catch (error) {
    throw error;
  }
}; */

const TrainingService = {
  getAllGroup,
  getAllSuggettions,
  getGroupDetails,
  createTrainingGroup,
  updateGroup,
  deleteUser,
  deleteGroup,
  deleteSuggestion,
  //   updateAdminProfile,
  //   adminFileUpload,
  //   getCompany,
};

export default TrainingService;
